module.exports = __webpack_public_path__ + "img/34.cc5944af.png";